import reduceReducer from 'reduce-reducers';
import { routerReducer } from 'react-router-redux';
/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers would not be hot-reloadable
 */

import { combineReducers } from 'redux';
import data from './data';
import landing from './landing';
import indicator from './indicator';
import indicatorMeta from './indicatorMeta';
import geography from './geography';
import filter from './filter';
import uiFlag from './uiFlag';

const combined = combineReducers({
  data: reduceReducer(
    data,
    landing,
    indicator,
    indicatorMeta,
    geography,
    filter,
    uiFlag,
  ),
  router: routerReducer,
});

// export default reduceReducer(combined);
export default combined;



// WEBPACK FOOTER //
// ./app/reducers/index.js